module.exports = __webpack_public_path__ + "static/media/18_plantilla_cuadrada_combo_simple_cp_stills_tetra_200_ades_nar.89ea12db.png";